import {HStack, Icon, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {VehicleSelectionOutcomeResponseBody} from '@dms/api/sales';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {getVehicleSelectionAttributeLabel} from '../../../utils/getVehicleSelectionAttributeLabel';
import {getVehicleSelectionOperatorLabel} from '../utils/getVehicleSelectionOperatorLabel';

export type VehicleSelectionOutcomeValueFormatter = (
  outcome: VehicleSelectionOutcomeResponseBody,
  value: unknown
) => string;

interface VehicleSelectionOutcomeListProps extends RequiredTestIdProps {
  outcomes: VehicleSelectionOutcomeResponseBody[];
  formatValue: VehicleSelectionOutcomeValueFormatter;
}

// One line per condition: what the rule asks for, and in brackets what the listing has.
export function VehicleSelectionOutcomeList(props: VehicleSelectionOutcomeListProps) {
  const describe = (outcome: VehicleSelectionOutcomeResponseBody) => {
    const expected = isNotNil(outcome.expected)
      ? ` ${props.formatValue(outcome, outcome.expected)}`
      : '';

    return `${getVehicleSelectionAttributeLabel(outcome.attribute)} ${getVehicleSelectionOperatorLabel(outcome.operator)}${expected}`;
  };

  return (
    <VStack spacing={1}>
      {props.outcomes.map((outcome, index) => (
        <HStack
          key={`${outcome.attribute}-${outcome.operator}`}
          spacing={1}
          align="center"
          data-testid={suffixTestId(`[${index}]`, props)}
        >
          <Icon
            value={outcome.matched ? 'action/check_circle' : 'navigation/cancel'}
            color={outcome.matched ? 'severity.success' : 'severity.danger'}
            size={4}
          />
          <Text size="xSmall">{describe(outcome)}</Text>
          <Text size="xSmall" color="tertiary">
            {`(${props.formatValue(outcome, outcome.actual)})`}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
}
